<div id="print-section" class="report-container">

  <!-- ===== HEADER ===== -->
  <table class="header-table" style="width: 100%; border-collapse: collapse; border-bottom: 1px solid black;">
    <tr>
      <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;">
        हिंदुस्तान प्रकाशन संस्था
      </td>
      <td style="font-size:18px; font-weight:bold; text-align:center;">
        Business Report
      </td>
      <td style="font-size:18px; text-align:right; padding:8px; font-weight:bold;">
        दिनांक : {{ today | date:'dd-MM-yyyy' }}
      </td>
    </tr>
    <tr style="border-top:1px solid black;">
      <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;">
        विवेक पुस्तक प्रकाशन
      </td>
      <td style="font-size:18px; font-weight:bold; text-align:center;">
        Briefly
      </td>
      <td style="font-size:18px; text-align:right; padding:8px; font-weight:bold;">
        From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
      </td>
    </tr>
  </table>

  <!-- ===== TABLE ===== -->
  <div class="table-wrapper" style="overflow-x:auto; ">
    <table class="report-table" style="border-collapse: collapse; width: 100%; table-layout: fixed;">

      <thead>
        <tr>
          <th rowspan="2" style="border:1px solid black; padding:6px; width:50px;">अ.क्र.</th>
          <th rowspan="2" style="border:1px solid black; padding:6px; width:190px;">कार्यालय प्रतिनिधी</th>
          <th rowspan="2" style="border:1px solid black; padding:6px; width:120px;">वार्षिक उद्दीष्ठ</th>

          <th *ngFor="let m of months" colspan="2" style="border:1px solid black; padding:6px; width:120px;">
            {{ m }}
          </th>

          <th colspan="2" style="border:1px solid black; padding:6px; width:150px;">एकुण</th>
          <th rowspan="2" style="border:1px solid black; padding:6px; width:100px;">फरक</th>
        </tr>

        <tr>
          <ng-container *ngFor="let m of months">
            <th style="border:1px solid black; padding:6px; width:150px;">बिल<br>रक्कम</th>
            <th style="border:1px solid black; padding:6px; width:150px;">जमा<br>रक्कम</th>
          </ng-container>

          <th style="border:1px solid black; padding:6px; width:160px;">एकुण<br>बिल रक्कम</th>
          <th style="border:1px solid black; padding:6px; width:160px;">एकुण<br>जमा रक्कम</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let group of reportData; let i = index">

          <td style="border:1px solid black; text-align:center;">{{ i + 1 }}</td>

          <td style="border:1px solid black; text-align:left; padding-left:8px;">
            {{ group.office_rep_name }}
          </td>

        <td style="border:1px solid black; text-align:right;">
  <input type="number"
         min="0"
         [(ngModel)]="group.uddisht"
         (ngModelChange)="onUddishtChange(group)"
         class="input-box"
         style="width:100px; text-align:right; padding:3px; border:1px solid #999; border-radius:3px;">
</td>

          <ng-container *ngFor="let m of months">
            <td style="border:1px solid black; text-align:right;">
              {{ group[m + '_billing']  }}
            </td>
            <td style="border:1px solid black; text-align:right;">
              {{ group[m + '_received']  }}
            </td>
          </ng-container>

          <td style="border:1px solid black; font-weight:bold; text-align:right;">
            {{ group.total_billing  }}
          </td>

          <td style="border:1px solid black; font-weight:bold; text-align:right;">
            {{ group.total_received  }}
          </td>

<td class="right bold"
    [style.color]="getFarak(group) > 0 ? 'green' : (getFarak(group) < 0 ? 'red' : 'black')"
    style="border:1px solid black; font-weight:bold; text-align:right;">

  {{ getFarak(group) > 0 ? '+' + getFarak(group) : getFarak(group) }}

</td>

        </tr>
      </tbody>

      <tfoot>
        <tr style="background-color:#c8753f;font-weight:bold;">
          <td colspan="2" style="border:1px solid black; text-align:right; padding-right:8px;">Grand Total</td>

          <td style="border:1px solid black; text-align:right;">
            {{ grandTotals.uddisht  }}
          </td>

          <ng-container *ngFor="let m of months">
            <td style="border:1px solid black; text-align:right;">
              {{ grandTotals[m + '_billing']}}
            </td>
            <td style="border:1px solid black; text-align:right;">
              {{ grandTotals[m + '_received']  }}
            </td>
          </ng-container>

          <td style="border:1px solid black; text-align:right;">
            {{ grandTotals.total_billing  }}
          </td>

          <td style="border:1px solid black; text-align:right;">
            {{ grandTotals.total_received  }}
          </td>

          <td class="right bold"
              [ngClass]="{'negative': getGrandFarak() < 0, 'positive': getGrandFarak() > 0}"
              style="border:1px solid black; font-weight:bold; text-align:right; color: inherit;">
            {{ getGrandFarak()  }}
          </td>
        </tr>
      </tfoot>

    </table>
  </div>

  <!-- ===== BUTTONS ===== -->
  <div class="btn-section noPrint" style="margin-top: 15px; text-align:center;">
     <button mat-button mat-dialog-close>❌ Close</button>
      <button mat-raised-button color="primary" (click)="exportExcel('OfficeWise_Report')" style="margin-right: 10px;">📊 Export</button>  
    <button  mat-raised-button color="accent" (click)="printReportA3()">🖨️ Print</button>
  </div>

</div>